const types = {
	//Get User
	GET_EXTERNAL_USER_START: "GET_EXTERNAL_USER_START",
	GET_EXTERNAL_USER_SUCCESS: "GET_EXTERNAL_USER_SUCCESS",
	GET_EXTERNAL_USER_ERROR: "GET_EXTERNAL_USER_ERROR",
	GET_EXTERNAL_USER_RESET: "GET_EXTERNAL_USER_RESET",

	//create User

	CREATE_EXTERNAL_USER_START: "CREATE_EXTERNAL_USER_START",
	CREATE_EXTERNAL_USER_SUCCESS: "CREATE_EXTERNAL_USER_SUCCESS",
	CREATE_EXTERNAL_USER_ERROR: "CREATE_EXTERNAL_USER_ERROR",
	CREATE_EXTERNAL_USER_RESET: "CREATE_EXTERNAL_USER_RESET",

	//delete user
	DELETE_EXTERNAL_USER_START: "DELETE_EXTERNAL_USER_START",
	DELETE_EXTERNAL_USER_SUCCESS: "DELETE_EXTERNAL_USER_SUCCESS",
	DELETE_EXTERNAL_USER_ERROR: "DELETE_EXTERNAL_USER_ERROR",
	DELETE_EXTERNAL_USER_RESET: "DELETE_EXTERNAL_USER_RESET",

	//update user

	UPDATE_EXTERNAL_USER_START: "UPDATE_EXTERNAL_USER_START",
	UPDATE_EXTERNAL_USER_SUCCESS: "UPDATE_EXTERNAL_USER_SUCCESS",
	UPDATE_EXTERNAL_USER_ERROR: "UPDATE_EXTERNAL_USER_ERROR",
	UPDATE_EXTERNAL_USER_RESET: "UPDATE_EXTERNAL_USER_RESET",
};

export default types;
